import { START_SAVING, STOP_SAVING } from './savingTypes';

const initialState = {
  isSaving: false,
  dialogConfig: {
    icon: '💾',
    title: 'Saving Changes',
    description: 'Hang on! Completing your current action...',
    hideProgress: false,
  },
};

const savingReducer = (state = initialState, action) => {
  switch (action.type) {
    case START_SAVING:
      return {
        ...state,
        isSaving: true,
        dialogConfig: {
          ...state.dialogConfig,
          ...action.payload,
        },
      };
    case STOP_SAVING:
      return {
        ...state,
        isSaving: false,
      };
    default:
      return state;
  }
};

export default savingReducer;
